import React from 'react'
import glass from '../data/glass'

class GlassSelect extends React.Component {
    render() {
        return (
            <select {...this.props}>
                { glass.map(glassType => (
                    <option key={glassType.name} value={glassType.name}>{glassType.name}</option>
                ))}
            </select>
        )
    }
}

export default GlassSelect


// WEBPACK FOOTER //
// ./src/components/GlassSelect.js